// extracted by mini-css-extract-plugin
export default {"error":"password_validator_error__pTPwV"};